module.exports = __webpack_public_path__ + "img/longgang.fbafcd5c.png";